module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/carousel_tiktok_mobile_08@2x-44acbcd64eaec7395476e0ff71c51456.jpg";